import BillableItemType from "../../../utils/enums/BillableItemType";
import MedocUnit from "../../pharmacy/model/MedocUnit";
import BillableItem from "./BillableItem";

export default class AltMedocInfo extends BillableItem {
    price!: number;
    discountRate!: number;
    remainingQuantity!: number;
    unit!: MedocUnit;

    constructor(name: string, unit: MedocUnit, version: number = 1) {
		super(name, BillableItemType.MEDOC, version);
		this.unit = unit;
	}
    
}